import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/sdc-cocina-saludable.png";
import thnksImg from "../assets/images/gracias.png";


const Thanks = () => {
  return (
    <React.Fragment>
      <header>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img src={thnksImg} style={{maxWidth: '100%'}} alt="" />
            </div>
            {/* <div className="col-7 pr-0 d-flex align-items-center">
              <img className="logo mr-2" src={logo} alt="Cocina Saludable" />
              <span className="slogan">¡Gracias por tu compra!</span>
            </div>
            <div className="col-5 pl-0 text-right pt-4">
              <Link
                to="/"
                className="btn btn-outline btn-up d-inline-block mb-4"
              >
                Obtener otra suscripción
              </Link>
            </div> */}
          </div>
        </div>
      </header>
      <section id="principal">
        <div className="container" style={{marginBottom:'10%', marginTop: '7%'}}>
          <div className="row">
            <div className="col-12">
              <p>
                ¡Tu pago fue aprobado!<br/>
                En el transcurso de la semana vas a recibir todas la información de plan nutricional para que empieces a cuidarte más saludablemente.<br/>
                Cualquier duda o comentario, escribinos a sabordecasa@oneminetta.com indicando tu nombre y teléfono.


              </p>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Thanks;
